/* eslint-disable prefer-template */
window.selectWrappers = [];

const limelightSelects = function limelightSelects() {
  const { Limelight, selectWrappers } = window;

  const updateSelects = function updateSelects() {
    const startingIndex = selectWrappers.length;
    const selects = document.querySelectorAll('[data-trigger="dropdown"]');

    selects.forEach((element, index) => {
      const i = startingIndex + index;

      if (!element.classList.contains('limelight-initialised')) {
        element.classList.add('limelight-initialised');
        selectWrappers[i] = new Limelight('' + element.dataset.target, {
          beforeShowCallback: function beforeShowCallback(element, elements) {
            selectWrappers.forEach((select, ind) => {
              if (Limelight.elements[select.target]) {
                Limelight.elements[select.target].hide();
              }
            });
          },
          hideCallback: function hideCallback(e) {
            const options = e.element.querySelector('.dropdown-options');
            if (options) {
              options.scrollTop = 0;
            }
          }
        });
      }
    });
  };

  document.addEventListener('click', (event) => {
    selectWrappers.forEach(function (select, index) {
      if (Limelight.elements[select.target]) {
        Limelight.elements[select.target].hide();
      }
    });
  });

  document.addEventListener('selects:update', updateSelects);
  updateSelects();
};

exports.default = limelightSelects;